import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "grid grid-cols-1 lg:grid-cols-2 gap-10 items-start"
}
const _hoisted_2 = { class: "grid grid-cols-1 gap-y-2" }
const _hoisted_3 = { class: "grid grid-cols-1 gap-y-2" }
const _hoisted_4 = { class: "flex items-start mt-1" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-map-marker-alt mr-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_input = _resolveComponent("the-input")!
  const _component_phone_number = _resolveComponent("phone-number")!
  const _component_the_select = _resolveComponent("the-select")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_the_textarea = _resolveComponent("the-textarea")!
  const _component_geocoder = _resolveComponent("geocoder")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    class: "auto",
    title: _ctx.modalTitle,
    "confirm-button-text": _ctx.modalConfirmButtonText,
    "confirm-button-class": _ctx.isDelete ? 'small red' : undefined,
    "confirm-message": `Вы действительно хотите удалить отправной пункт?`,
    "is-confirm": _ctx.isDelete,
    loading: _ctx.loading,
    scrollable: "",
    onCancel: _ctx.emitCancel,
    onConfirm: _ctx.emitManager
  }, {
    default: _withCtx(() => [
      (!_ctx.geocode_state.is_opened)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_the_input, {
                placeholder: "Имя получателя (пользователь)",
                value: _ctx.payload.fullName,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.payload.fullName) = $event)),
                "is-invalid": _ctx.state_form$.fullName.$error,
                "validation-errors": _ctx.state_form$.fullName.$errors
              }, null, 8, ["value", "is-invalid", "validation-errors"]),
              _createVNode(_component_phone_number, {
                class: "mt-2",
                placeholder: "Телефон",
                value: _ctx.payload.phone,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.payload.phone) = $event)),
                "is-invalid": _ctx.state_form$.phone.$error,
                "validation-errors": _ctx.state_form$.phone.$errors
              }, null, 8, ["value", "is-invalid", "validation-errors"])
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_the_select, {
                value: _ctx.payload.cityId,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.payload.cityId) = $event)),
                placeholder: "Выберите город",
                "is-invalid": _ctx.state_form$.cityId.$error,
                "validation-errors": _ctx.state_form$.cityId.$errors,
                loading: _ctx.data_state.cities.is_loading,
                options: _ctx.data_state.cities.list,
                failed: _ctx.data_state.cities.is_failed,
                "error-text": "При получении списка городов произошла ошибка",
                "search-by": "name",
                "select-by": "id",
                label: "name",
                "infinite-scroll": "",
                onRefresh: _cache[3] || (_cache[3] = ($event: any) => (_ctx.loadCities(_ctx.data_state.cities.pagination.current_page))),
                onChange: _ctx.onCitySelect,
                disabled: Boolean(_ctx.receiverCityId)
              }, null, 8, ["value", "is-invalid", "validation-errors", "loading", "options", "failed", "onChange", "disabled"]),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_the_input, {
                  value: _ctx.payload.fullAddress,
                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.payload.fullAddress) = $event)),
                  disabled: "",
                  class: "w-3/5",
                  placeholder: "Адрес",
                  "is-invalid": _ctx.state_form$.fullAddress.$error,
                  "validation-errors": _ctx.state_form$.fullAddress.$errors
                }, null, 8, ["value", "is-invalid", "validation-errors"]),
                _createVNode(_component_the_button, {
                  class: "mt-3 ml-3 primary text small w-2/5",
                  disabled: _ctx.isAddressDisabled,
                  onClick: _ctx.onStartGeocode
                }, {
                  default: _withCtx(() => [
                    _hoisted_5,
                    _createTextVNode(" Указать ")
                  ]),
                  _: 1
                }, 8, ["disabled", "onClick"])
              ]),
              _createVNode(_component_the_input, {
                value: _ctx.payload.buildingNumber,
                "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.payload.buildingNumber) = $event)),
                placeholder: "Номер здания"
              }, null, 8, ["value"]),
              _createVNode(_component_the_input, {
                value: _ctx.payload.flatNumber,
                "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.payload.flatNumber) = $event)),
                placeholder: "Номер квартиры"
              }, null, 8, ["value"]),
              _createVNode(_component_the_textarea, {
                value: _ctx.payload.comment,
                "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.payload.comment) = $event)),
                placeholder: "Комментарий к адресу",
                autoheight: "",
                rows: 4
              }, null, 8, ["value"])
            ])
          ]))
        : (_openBlock(), _createBlock(_component_geocoder, {
            key: 1,
            city: _ctx.state.city,
            latitude: _ctx.payload.latitude,
            longitude: _ctx.payload.longitude,
            "full-address": _ctx.payload.fullAddress,
            onSetAddress: _ctx.onSetAddress
          }, null, 8, ["city", "latitude", "longitude", "full-address", "onSetAddress"]))
    ]),
    _: 1
  }, 8, ["title", "confirm-button-text", "confirm-button-class", "is-confirm", "loading", "onCancel", "onConfirm"]))
}